import IFilter from './IFilter';

/**
 * This class handle the Range Filters
 * @author Yadian
 * Example
 *  {
 "type": "RANGE",
 "field": "createdAt",
 "from": "2020-07-10",
 "to": "2020-07-16",
 "isDate": true,
 }
 **/


export default class RangeFilter extends IFilter {

  /**
   * @param filter {Object}
   **/
  constructor(filter) {
    super();
    const { field, from, to, isDate, isFromNotEqual, isToNotEqual } = filter;
    this.type = 'RANGE';
    this.field = field;
    this.from = from;
    this.isFromNotEqual = isFromNotEqual;
    this.isToNotEqual = isToNotEqual;
    this.to = to;
    this.isDate = isDate || false;
  }

  clone() {
    return new RangeFilter(this.toQuery());
  }

  toQuery() {
    if (this.from === undefined && this.to === undefined)
      return;

    return {
      type: 'RANGE',
      field: this.field,
      from: this.from,
      to: this.to,
      isDate: this.isDate,
    };
  }

  toMongoQuery() {
    const query = {};
    const isFromDefined = this.from != undefined && this.from != null;
    const isToDefined = this.to != undefined && this.to != null;
    if (!isFromDefined && !isToDefined)
      return null;
    if (isFromDefined)
      query[this.isFromNotEqual ? '$gt' : '$gte'] = this.isDate && Date.parse(this.from) ? new Date(this.from) : this.from;
    if (isToDefined)
      query[this.isToNotEqual ? '$lt' : '$lte'] = this.isDate && Date.parse(this.to) ? new Date(this.to) : this.to;
    return { [this.field]: query };
  }
}
